import { CheckPlannerPage } from '@/app/pages/check-planner/check-planner-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { BasicFiltersSchema } from '@/entities/listing/typings/api-types';

const checkPlannerSearchSchema = z.object({
  ...BasicFiltersSchema.shape,
  bookingType: z.union([
    z.literal('your-tour'),
    z.literal('accommodation'),
    z.literal('excursion'),
  ]),
  travelId: z.string(),
  propertyId: z.string(),
  roomTypeId: z.string(),
  ratePlanId: z.string(),
  checksum: z.string(),
  selectedDate: z.string().optional(),
});

export const Route = createFileRoute('/check-planner/')({
  validateSearch: checkPlannerSearchSchema,
  component: CheckPlannerPage,
});
